import { DepreciationChargesService } from "./../../../services/documents/DepreciationChargesService";
import React from "react";
import { IAppEntity } from "../../entities";
import { DocumentService } from "../../../services/documents/DocumentService";
import { ICreateCustomerInvoicesDto } from "../../../components/Pages/Documents/CustomerInvoices/dtos/ICreateCustomerInvoicesDto";
import { ReferenceTypes } from "../../../enums/ReferenceTypes";
import { DepreciationChargesDetail } from "../../../components/Pages/Documents/DepreciationCharges/DepreciationChargesDetail";
import { CreateDepreciationChargesDto } from "../../../dtos/documents/DepreciationCharges/CreateDepreciationChargesDto";
import { NFLookupDepreciationCharges } from "../../../components/Shared/NewForms/NFLookupDepreciationCharges";
import DepreciationChargesList from "../../../components/Pages/Documents/DepreciationCharges/DepreciationChargesList";

export const DepreciationCharges: IAppEntity = {
  entityType: "document",
  title: "Depreciation Charges",
  pluralTitle: "Depreciation Charges",
  apiUrl: "DepreciationCharges",
  apiEnum: ReferenceTypes.DocumentCustomerInvoice,
  getDetailViewComponent: (
    model: any,
    modelUpdatedEvent: (model: any) => void
  ) =>
    React.createElement(DepreciationChargesDetail, {
      model: model,
      modelUpdatedEvent: modelUpdatedEvent,
    }),
  getListView: (model: any, modelUpdatedEvent: (model: any) => void) =>
    React.createElement(DepreciationChargesList, {
      model: model,
      modelUpdatedEvent: modelUpdatedEvent,
    }),
  getLookupComponent(model: any): any {
    return React.createElement(NFLookupDepreciationCharges, {
      fieldName: model.fieldName,
      title: model.title,
      setSelectedCatalog: model.setSelectedCatalog,
    });
  },
  getDataService: () => new DepreciationChargesService("DepreciationCharges"),
  getEmptyModel: () => {
    const model: CreateDepreciationChargesDto = {
      totalAmount: 0,
      totalAmountVat: 0,
      documentDate: new Date(),
      documentNumber: "",
      status: 0,
      comment: "",
      createdDate: new Date(),
      
    };
    return model;
  },
};
